import { createStructuredSelector } from 'reselect';
import {
  TASK_VEHICLE_LIST, TASK_VEHICLE_LIST_SUCCESS, TASK_VEHICLE_LIST_ERROR,
  TASK_VEHICLE_PAGE_SET,
  TASK_VEHICLE_ADD, TASK_VEHICLE_ADD_SUCCESS, TASK_VEHICLE_ADD_ERROR,
  TASK_VEHICLE_ADD_CHANGE,
  TASK_VEHICLE_DETAIL, TASK_VEHICLE_DETAIL_SUCCESS, TASK_VEHICLE_DETAIL_ERROR,
  TASK_VEHICLE_UPDATE, TASK_VEHICLE_UPDATE_SUCCESS, TASK_VEHICLE_UPDATE_ERROR,
  TASK_VEHICLE_FILTER_VEHICLES, TASK_VEHICLE_FILTER_VEHICLES_SUCCESS,
} from '../../actions';

export const NAME = 'task_vehicle';

export const TaskVehicleList = (page, num_page, orderBy, filters) => ({ type: TASK_VEHICLE_LIST, payload: { page, num_page, orderBy, filters } });
export const TaskVehicleListSuccess = (data) => ({ type: TASK_VEHICLE_LIST_SUCCESS, payload: data });
export const TaskVehicleListError = (error) => ({ type: TASK_VEHICLE_LIST_ERROR, payload: error });
export const TaskVehiclePageSet = (data) => ({ type: TASK_VEHICLE_PAGE_SET, payload: data });
export const TaskVehicleAddChangeSet = (data) => ({ type: TASK_VEHICLE_ADD_CHANGE, payload: data });
export const TaskVehicleAdd = (data) => ({ type: TASK_VEHICLE_ADD, payload: data });
export const TaskVehicleAddSuccess = (message) => ({ type: TASK_VEHICLE_ADD_SUCCESS, payload: message });
export const TaskVehicleAddError = (error) => ({ type: TASK_VEHICLE_ADD_ERROR, payload: error });
export const TaskVehicleDetail = (data) => ({ type: TASK_VEHICLE_DETAIL, payload: data });
export const TaskVehicleDetailSuccess = (data) => ({ type: TASK_VEHICLE_DETAIL_SUCCESS, payload: data });
export const TaskVehicleDetailError = (error) => ({ type: TASK_VEHICLE_DETAIL_ERROR, payload: error });
export const TaskVehicleUpdate = (data) => ({ type: TASK_VEHICLE_UPDATE, payload: data });
export const TaskVehicleUpdateSuccess = (message) => ({ type: TASK_VEHICLE_UPDATE_SUCCESS, payload: message.message });
export const TaskVehicleUpdateError = (error) => ({ type: TASK_VEHICLE_UPDATE_ERROR, payload: error });
export const TaskVehicleFilterVehicles = (id_supplier) => ({ type: TASK_VEHICLE_FILTER_VEHICLES, payload: { id_supplier } });
export const TaskVehicleFilterVehiclesSuccess = (data) => ({ type: TASK_VEHICLE_FILTER_VEHICLES_SUCCESS, payload: data });

const task_vehicle = (state) => state[NAME];
export const TaskVehicleSelector = createStructuredSelector({ task_vehicle });
